<template>
  <b-container fluid>
    <!-- User Interface controls -->
    <b-row>
      <b-col
        lg="6"
        class="my-1"
      >
        <h5>{{ this.titulo }}</h5>
        <p><b>{{ this.error }}</b></p>
        <b-form-group>
        <b-input-group size="sm">
          <div class="form-check">
            <input id="solo_siniestros_abiertos" class="form-check-input" type="checkbox" value="true" :checked="filtrar_abiertos == true" @change="filterCompleted($event)">
            <label class="form-check-label" for="solo_siniestros_abiertos">
              Mostrar sólo siniestros abiertos (los cerrados se muestran en verde)
            </label>
          </div>
        </b-input-group>
        </b-form-group>
      </b-col>

      <b-col
        lg="6"
        class="my-1"
      >
        <b-form-group
          label="Cuadro de búsqueda"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Escribe cualquier palabra que quieras buscar"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Main table element -->
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :sort-compare="nestedSortCompare"
      stacked="md"
      show-empty
      small
      @filtered="onFiltered"
      empty-text=""
      @row-clicked="onRowClicked"
    >
      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

      <template #row-details="row">
        <b-card>
          <b>Detalle del siniestro {{ row.item.claim_company_reference }}</b>
          <hr />
          <p>
            <b>Descripción: {{ row.item.description }}</b>
          </p>
          <hr />
          <p>
            <b>Última actualización ({{ row.item.last_update_date }}):</b>
          </p>
          <p>{{ row.item.last_update_subject }}</p>
          <b-row>
            <b-col
              lg="6"
              class="my-1"
            >
              <b-button
                size="sm"
                @click="showClaimLog(row.item)"
              >Ver historial</b-button>
            </b-col>
            <b-col
              lg="3"
              class="my-1"
              v-if="claimIsFinished(row.item)"
            >
            </b-col>
            <b-col
              lg="3"
              class="my-1"
              v-if="claimIsFinished(row.item)"
              @click="showFileManager(row.item)"
            >
              <b-button size="sm">Comunicación a departamento de siniestros sobre este
                siniestro</b-button>
            </b-col>
          </b-row>
        </b-card>
      </template>
    </b-table>
    <center>
      <moon-loader
        :loading="loadingTable"
        color="green"
        size="80px"
      ></moon-loader>
      <br />
    </center>
    <b-row>
      <b-col
        sm="12"
        md="12"
        class="my-1"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
          first-text="Primera"
          prev-text="Anterior"
          next-text="Siguiente"
          last-text="Última"
        ></b-pagination>
      </b-col>
    </b-row>
    <!-- Info modal -->
    <b-modal
      scrollable
      ok-only
      ok-variant="secondary"
      ok-title="OK"
      size="xl"
      id="claim-log"
      ref="claim-log"
      title="Histórico de gestiones del siniestro"
    >
      <template v-slot:modal-header-close>
        <i class="fa fa-close"></i>
      </template>
      <ListadoGestiones :claim="claimSelected"></ListadoGestiones>
    </b-modal>
    <b-modal
      hide-footer
      size="xl"
      id="file-manager"
      ref="file-manager"
      :title="tituloEmailClaimSelected(claimSelected)"
    >
      <template v-slot:modal-header-close>
        <i class="fa fa-close"></i>
      </template>
      <GestionFicheros :claim="claimSelected"></GestionFicheros>
    </b-modal>
  </b-container>
</template>

<script>
import { insuranceClaimsService } from "@/src/../_services";
import moment from "moment";
import MoonLoader from "vue-spinner/src/MoonLoader.vue";
import ListadoGestiones from "@/components/Siniestros/ListadoGestiones";
import GestionFicheros from "@/components/Siniestros/GestionFicheros";

export default {
  name: "ListadoSiniestros",
  components: {
    MoonLoader: MoonLoader,
    ListadoGestiones,
    GestionFicheros,
  },
  props: ["poliza", "siniestro"],
  data () {
    return {
      titulo: "Todos tus siniestros",
      visibleRow: null,
      loadingTable: true,
      insuranceClaims: [],
      items: [],
      claimSelected: {},
      error: "",
      filtrar_abiertos: true,
      fields: [
        {
          key: "claim_company_reference",
          label: "Referencia",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "policy_company_id",
          label: "Póliza",
          sortable: true,
          class: "text-center",
        },
        {
          key: "cli_business_name",
          label: "Cliente",
          sortable: true,
          class: "text-center",
        },
        {
          key: "policy_company_business_name",
          label: "Compañía",
          sortable: true,
          class: "text-center",
        },
        {
          key: "line_of_insurance_description",
          label: "Ramo",
          sortable: true,
          class: "text-center",
        },
        {
          key: "claim_start_date",
          label: "Fecha de siniestro",
          sortable: true,
          class: "text-center",
        },
        {
          key: "claim_end_date",
          label: "Fecha de resolución",
          sortable: true,
          class: "text-center",
        },
        {
          key: "last_update_date",
          label: "Ultima actualización",
          sortable: true,
          class: "text-center",
        },
        { key: "actions", label: "Opciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 7,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  async mounted () {
    // Set the initial number of items
    this.totalRows = this.items.length;
    if (this.poliza === undefined || this.poliza === null) {
      await this.get_all_claims();
    } else {
      await this.get_all_claims_from_policy();
    }
    this.manageError(this.insuranceClaims)
    if (this.error == "") {
      this.items = insuranceClaimsService.getInsuranceClaimsTable(
        this.insuranceClaims
      );
    }
    this.totalRows = this.items.length;
    this.loadingTable = false;
  },
  methods: {
    filterCompleted(event) {
      this.loadingTable = true;
      this.filtrar_abiertos = !this.filtrar_abiertos
      this.items = insuranceClaimsService.getInsuranceClaimsTable(
        this.insuranceClaims, this.filtrar_abiertos
      );
      console.log("Filtrado")
      this.totalRows = this.items.length;
      this.loadingTable = false;
    },
    async get_all_claims(filterNonClosed = true) {
      console.log(filterNonClosed)
      if (this.siniestro === undefined && this.siniestro === null) {
        this.titulo = "Todos tus siniestros";
        this.insuranceClaims =
          await insuranceClaimsService.getInsuranceClaims(filterNonClosed);
        this.manageError(this.insuranceClaims)
      } else {
        this.filter = this.siniestro;
        this.titulo = "Todos tus siniestros";
        this.insuranceClaims =
          await insuranceClaimsService.getInsuranceClaims(filterNonClosed);
        this.manageError(this.insuranceClaims)
      }
    },
    async get_all_claims_from_policy() {
      this.titulo = "Siniestros de la póliza " + this.poliza;
      this.insuranceClaims =
        await insuranceClaimsService.getInsuranceClaimsOfPolicy(this.poliza);
      this.manageError(this.insuranceClaims)
    },
    tituloEmailClaimSelected (claimSelected) {
      return `Siniestro: ${claimSelected.claim_id} de ${claimSelected.cli_business_name} | Póliza: ${claimSelected.policy_company_id} (${claimSelected.policy_company_business_name})`;
    },
    manageError (responseData) {
      if (responseData["error"] !== undefined) {
        switch (responseData["error"].response.status) {
          case 401:
            // La sesión ha caducado. A la página de login
            console.log(`Error: ${this.misPolizas["error"].response.status}`)
            this.$router.push('login');
            break;
          case 404:
            // La sesión ha caducado. A la página de login
            console.log("No hay datos")
            this.error = "No hay siniestros que mostrar"
            break;
          default:
            console.log(`Error: ${this.misPolizas["error"].response.status}`)
            break;
        }
      }
    },
    nestedSortCompare (valOne, valTwo, key) {
      console.log("comparando campos " + moment(valOne.claim_start_date, "DD/MM/YYYY").format('YYYYMMDD') + '+' + moment(valTwo.claim_start_date, "DD/MM/YYYY").format('YYYYMMDD'));
      switch (key) {
        case "claim_start_date":
          console.log(moment(valOne.claim_start_date, "DD/MM/YYYY") < moment(valTwo.claim_start_date, "DD/MM/YYYY"))

          if (valOne.claim_start_date == '')
            return true

          if (valTwo.claim_start_date == '')
            return false

          return (
            moment(valOne.claim_start_date, "DD/MM/YYYY").format('YYYYMMDD') < moment(valTwo.claim_start_date, "DD/MM/YYYY").format('YYYYMMDD')

          );
        case "claim_end_date":

          if (valOne.claim_end_date === null)
            return true

          if (valTwo.claim_end_date === null)
            return false

          return (
            moment(valOne.claim_end_date, "DD/MM/YYYY") < moment(valTwo.claim_end_date, "DD/MM/YYYY")
          );
        case "last_update_date":

          if (valOne.last_update_date === null)
            return true

          if (valTwo.last_update_date === null)
            return false

          return (
            moment(valOne.last_update_date, "DD/MM/YYYY") < moment(valTwo.last_update_date, "DD/MM/YYYY")
          );
        default:
          return null;
      }
    },
    showClaimLog (claim) {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.claimSelected = claim;
      this.$refs["claim-log"].show();
    },
    showFileManager (claim) {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.claimSelected = claim;
      this.$refs["file-manager"].show();
    },
    claimIsFinished (claim) {
      if (claim.claim_end_date) return false;
      else return true;
    },
    info (item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal () {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onRowClicked (item) {
      const { detailsRow } = this;
      if (detailsRow && detailsRow !== item) {
        detailsRow._showDetails = false;
      }

      this.$set(item, "_showDetails", !item._showDetails);
      this.detailsRow = item;
    },
  },
};
</script>
<style>
.table {
  font-size: 0.8em !important;
  font-weight: 300;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #8fd19e !important;
  border-color: #8fd19e !important;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #1e4827 !important;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>
